import { shouldPolyfill } from '@formatjs/intl-numberformat/should-polyfill';

export async function loadIntlNumberFormat(locale) {
  const unsupportedLocale = shouldPolyfill(locale);
  // This locale is supported
  if (!unsupportedLocale) {
    return;
  }
  // Load the polyfill 1st BEFORE loading data
  await import(
    /* webpackChunkName: "polyfill/intl-numberformat/polyfill-force" */
    '@formatjs/intl-numberformat/polyfill-force'
  );
  await import(
    /* webpackChunkName: "polyfill/intl-numberformat/locale-data" */
    `@formatjs/intl-numberformat/locale-data/${unsupportedLocale}.js`
  );
}
